export default {
  titles: {
    locale: 'Valitse kieli', // Kielivalikon otsikko ruudunlukijoita varten
    search: 'Määritä hakuehdot', // Hakulomakkeen otsikko ruudunlukijoita varten
    candidates: 'Ehdokkaat', // Ehdokaslistauksen otsikko ruudunlukijoita varten
    candidateInSocialMedia: 'Ehdokas sosiaalisessa mediassa', // Ehdokkaan somelinkkien otsikko ruudunlukijoita varten
    donationSum: 'Lahjoituksen summa',
    companyDetails: 'Yrityksen/yhteisön tiedot',
    donorDetails: 'Lahjoittajan tiedot',
    thanksForYourDonation: 'Kiitos lahjoituksestasi!',
  },
  infoTexts: {
    selectElection: 'Aloita valitsemalla vaali.',
    selectConstituency: 'Aloita valitsemalla vaalipiiri.',
    selectCommune: 'Aloita valitsemalla kunta.',
    selectWelfareArea: 'Aloita valitsemalla hyvinvointialue.',
    loadingCandidates: 'Ladataan ehdokkaita.',
    noCandidatesFound: 'Haulla ei löytynyt ehdokkaita.',
    candidatesFound: 'Haulla löytyi yksi ehdokas. | Haulla löytyi {count} ehdokasta.',
    defineSearchTerms: 'Määritä haluamasi hakuehdot ehdokkaille',
    defineEmbedConfig: 'Määritä alla upotuksen asetukset',
    pasteEmbedCode: 'Kopioi ja liitä alla oleva upotuskoodi sivustosi koodiin',
    checkingPayment: 'Tarkistetaan maksua',
    paymentCheckFailed: 'Maksun tarkistaminen epäonnistui',
  },
  candidate: {
    number: 'Ehdokasnumero',
    age: 'Ikä',
    years: 'vuotta',
    yearsAbbreviation: 'v',
    independentAbbreviation: 'sit.',
    donationNotify: 'Lahjoita',
    commune: 'Kunta',
    website: 'Kotisivu',
    title: 'Ammatti',
  },
  buttons: {
    back: {
      label: 'Takaisin',
    },
    closeWindow: {
      label: 'Sulje ikkuna',
    },
    showMore: {
      label: 'Näytä lisää',
    },
    showLess: {
      label: 'Näytä vähemmän',
    },
    tryAgain: {
      label: 'Yritä uudelleen',
    },
    embed: {
      label: 'Upota ehdokaslistaus verkkosivuille',
    },
    donate: {
      label: 'Lahjoita',
    },
    share: {
      label: 'Jaa',
    },
    copyLink: {
      card: {
        label: 'Kopioi ehdokaskortin linkki',
      },
      donation: {
        label: 'Kopioi lahjoituslomakkeen linkki',
      },
      success: 'Linkki kopioitu leikepöydälle.',
      error: 'Linkin kopiointi epäonnistui. Voit kopioida linkin suoraan tästä.',
    },
    shareInFacebook: {
      label: 'Jaa Facebookissa',
    },
    shareInTwitter: {
      label: 'Jaa X:ssä',
    },
    proceedToPayment: {
      label: 'Siirry maksamaan',
      notes: 'Rahankeräysluvan tiedot',
    },
    proceedToPaymentService: {
      label: 'Siirry maksamaan',
      notes: 'Sinut ohjataan automaattisesti maksupalveluun. Jos uudelleenohjaus ei toimi, klikkaa yllä olevasta napista.',
    },
  },
  fields: {
    election: {
      label: 'Vaali',
    },
    commune: {
      label: 'Kunta',
    },
    constituency: {
      label: 'Vaalipiiri',
    },
    welfareArea: {
      label: 'Hyvinvointialue',
    },
    gender: {
      label: 'Sukupuoli',
    },
    age: {
      label: 'Ikä',
    },
    sum: {
      label: 'Lahjoituksen summa',
      notes: 'Lahjoituksesta vähennetään maksutavasta riippuva palvelumaksu.',
    },
    sumCustom: {
      label: 'Muu summa',
      notes: 'Pienin lahjoitettava summa on 5 €.',
    },
    behalfCompany: {
      label: 'Lahjoitan yrityksen/yhteisön puolesta',
    },
    organizationName: {
      label: 'Organisaation nimi',
    },
    vatId: {
      label: 'Y-tunnus',
    },
    organizationType: {
      label: 'Organisaation tyyppi',
    },
    email: {
      label: 'Sähköpostiosoite',
    },
    firstName: {
      label: 'Etunimi',
    },
    lastName: {
      label: 'Sukunimi',
    },
    donationAbroad: {
      label: 'En asu Suomessa',
    },
    postal: {
      label: 'Postinumero',
    },
    country: {
      label: 'Maa',
    },
    locality: {
      label: 'Kotipaikka',
    },
    message: {
      label: 'Viesti lahjoituksen saajalle',
    },
    donorContact: {
      label: 'Minuun saa olla yhteydessä myös jatkossa',
      notes: 'Tietojani käsitellään tietosuojaselosteen mukaisesti',
    },
    donorPublic: {
      label: 'Lahjoittajan saa julkistaa',
      notes: 'Valitse tässä, onko tieto tekemästäsi lahjoituksesta julkinen. Mikäli kiellät tiedon julkaisun, niin tällöin tieto tekemästäsi lahjoituksesta jää KD:lle ja lahjoituksesi kohteelle, eikä sitä julkisteta missään. Valinnainen julkistaminen koskee vain alle 800 euron lahjoittamista yksittäiselle ehdokkaalle. Yli 800 euron lahjoitukset ehdokkaan on KD:n käytäntöjen mukaisesti julkistettava. Mikäli lahjoitat KD:n palvelujen kautta useammalle kohteelle yhteensä yli 1500 euroa, tehtyjen lahjoitusten tekijä on puoluelain mukaan julkistettava, vaikka yksittäisen kohteen kohdalla 800 euron raja ei ylittyisi. Kohteita ei tällöin julkisteta.',
    },
    donorTermsAccepted: {
      label: 'Olen tutustunut lahjoittajarekisterin rekisteri- ja tietosuojaselosteeseen',
    },
    // Upotuskoodin luonti
    showLocale: {
      label: 'Näytä kielen valinta',
    },
    showSearch: {
      label: 'Näytä hakulomake',
    },
    showCommune: {
      label: 'Näytä kunnan valinta',
    },
    showConstituency: {
      label: 'Näytä vaalipiirin valinta',
    },
    showWelfareArea: {
      label: 'Näytä hyvinvointialueen valinta',
    },
    showGender: {
      label: 'Näytä sukupuolen valinta',
    },
    showAge: {
      label: 'Näytä iän valinta',
    },
    showSummary: {
      label: 'Näytä hakutulosten yhteenveto',
    },
    autoPager: {
      label: 'Automaattinen sivutus',
    },
    candidate_type: {
      label: 'Ehdokkaan tyyppi',
    },
    all: {
      label: 'Kaikki',
    },
    green_women: {
      label: 'Vihreät naiset',
    },
    green_youth: {
      label: 'Vihreät nuoret',
    },
    green_viite: {
      label: 'Viite',
    },
    embedCode: {
      label: 'Upotuskoodi',
    },
  },
}
